import React from "react";

import {
  ADDRESS,
  CAD,
  CHUTE,
  WINDOW,
  PARCEL_NUMBER,
  LOAD,
  INFORMATION,
  TYPE_OF_COLLECTION,
  POSTCODE,
  STOP,
  PARCELS,
  CADS,
  STOP_TIME,
  EXCEPTION,
} from "../../constants/strings";
import { COLUMN_ACCESSORS } from "../../constants/table";
import BodyCell from "../../components/common/Table/BodyCell";
import HeaderCell from "../../components/common/Table/HeaderCell";
import { Add, Remove, SpotIcon } from "../../components/icons";
import palette from "../../components/styles/palette";
import {
  HighValueItem,
  ServiceItem,
} from "../../components/common/Table/Items";
import {
  isRemoveRequest,
  getExceptionEntry,
  getCadScannedStatusColor,
  getCadStatusTextColor,
} from "../routeDetail/model";
import { requestTypes } from "../../enums/requestTypes";

export const requestedParcelsColumns = ({
  headerCellClasses,
  bodyCellClasses,
  columnsConfigs,
}) => [
  {
    Cell: ({ rowData }) => {
      return (
        <HighValueItem
          rowData={rowData}
          classes={bodyCellClasses}
          // testId={`${CA.SERVICE}-icon-${getStatusTextColor(value)}`}
        />
      );
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.HIGH_VALUE],
    accessor: COLUMN_ACCESSORS.HIGH_VALUE,
  },
  {
    Header: () => {
      return <HeaderCell header="" classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      if (!value) {
        return <BodyCell value="" classes={bodyCellClasses} />;
      }
      const icon = isRemoveRequest({ requestType: value }) ? (
        <Remove />
      ) : (
        <Add />
      );
      return <BodyCell value={icon} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.REQUEST_TYPE],
    accessor: COLUMN_ACCESSORS.REQUEST_TYPE,
  },
  {
    Cell: ({ value }) => {
      return (
        <BodyCell
          value={<ServiceItem value={value} />}
          classes={bodyCellClasses}
        />
      );
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.SERVICE],
    accessor: COLUMN_ACCESSORS.SERVICE,
  },
  {
    Header: () => {
      return <HeaderCell header={PARCEL_NUMBER} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      return <BodyCell value={value} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.PARCEL_NUMBER],
    accessor: COLUMN_ACCESSORS.PARCEL_NUMBER,
  },
  {
    Header: () => {
      return <HeaderCell header={ADDRESS} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      return (
        <BodyCell
          value={value}
          classes={bodyCellClasses}
          extraCellClasses={[bodyCellClasses.cellCroppedText]}
        />
      );
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.ADDRESS],
    accessor: COLUMN_ACCESSORS.ADDRESS,
  },
  {
    Header: () => {
      return <HeaderCell header={CAD} classes={headerCellClasses} />;
    },
    Cell: ({ value, rowData }) => {
      const icon = (
        <SpotIcon color={getCadScannedStatusColor(value, rowData)} />
      );
      return (
        <BodyCell
          value={icon}
          classes={bodyCellClasses}
          data-testid={`${
            COLUMN_ACCESSORS.CAD_SCANNED
          }-icon-${getCadStatusTextColor(value, rowData)}`}
        />
      );
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.CAD_SCANNED],
    accessor: COLUMN_ACCESSORS.CAD_SCANNED,
  },
  {
    Header: () => {
      return <HeaderCell header={LOAD} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      const icon = (
        <SpotIcon
          color={value ? palette.statuses.statusGreen : palette.dpdRed}
        />
      );
      return <BodyCell value={icon} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.LOAD],
    accessor: COLUMN_ACCESSORS.LOAD,
  },
  {
    Header: () => {
      return <HeaderCell header={WINDOW} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      return <BodyCell value={value} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.WINDOW],
    accessor: COLUMN_ACCESSORS.WINDOW,
  },
  {
    Header: () => {
      return <HeaderCell header={CHUTE} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      return <BodyCell value={value} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.CHUTE],
    accessor: COLUMN_ACCESSORS.CHUTE,
  },
  {
    Header: () => {
      return <HeaderCell header={INFORMATION} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      return <BodyCell value={value} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.REQUEST_REASON],
    accessor: COLUMN_ACCESSORS.REQUEST_REASON,
  },
];

export const requestedCollectionColumns = ({
  headerCellClasses,
  bodyCellClasses,
  columnsConfigs,
}) => [
  {
    Header: () => {
      return <HeaderCell header="" classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      if (!value?.length) {
        return <BodyCell value="" classes={bodyCellClasses} />;
      }
      const icon =
        value === requestTypes.REMOVE_COLLECTION ? <Remove /> : <Add />;
      return <BodyCell value={icon} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.REQUEST_TYPE],
    accessor: COLUMN_ACCESSORS.REQUEST_TYPE,
  },
  {
    Header: () => {
      return (
        <HeaderCell header={TYPE_OF_COLLECTION} classes={headerCellClasses} />
      );
    },
    Cell: ({ value }) => {
      return <BodyCell value={value} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.TYPE_OF_COLLECTION],
    accessor: COLUMN_ACCESSORS.TYPE_OF_COLLECTION,
  },
  {
    Header: () => {
      return <HeaderCell header={ADDRESS} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      return <BodyCell value={value} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.ADDRESS],
    accessor: COLUMN_ACCESSORS.ADDRESS,
  },
  {
    Header: () => {
      return <HeaderCell header={POSTCODE} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      return <BodyCell value={value} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.POSTCODE],
    accessor: COLUMN_ACCESSORS.POSTCODE,
  },
  {
    Header: () => {
      return <HeaderCell header={WINDOW} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      return <BodyCell value={value} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.WINDOW],
    accessor: COLUMN_ACCESSORS.WINDOW,
  },
  {
    Header: () => {
      return <HeaderCell header={INFORMATION} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      return <BodyCell value={value} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.REQUEST_REASON],
    accessor: COLUMN_ACCESSORS.REQUEST_REASON,
  },
];

export const pickupRequestColumns = ({
  headerCellClasses,
  bodyCellClasses,
  columnsConfigs,
}) => [
  {
    Header: () => {
      return <HeaderCell header={STOP} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      return <BodyCell value={value} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.STOP_NUMBER],
    accessor: COLUMN_ACCESSORS.STOP_NUMBER,
  },
  {
    Header: () => {
      return <HeaderCell header={ADDRESS} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      return (
        <BodyCell
          value={value}
          classes={bodyCellClasses}
          extraCellClasses={[bodyCellClasses.cellCroppedText]}
        />
      );
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.ADDRESS],
    accessor: COLUMN_ACCESSORS.ADDRESS,
  },
  {
    Header: () => {
      return <HeaderCell header={POSTCODE} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      return <BodyCell value={value} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.POSTCODE],
    accessor: COLUMN_ACCESSORS.POSTCODE,
  },
  {
    Header: () => {
      return <HeaderCell header={PARCELS} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      return <BodyCell value={value} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.PARCELS],
    accessor: COLUMN_ACCESSORS.PARCELS,
  },
  {
    Header: () => {
      return <HeaderCell header={CADS} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      return <BodyCell value={value} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.CAD],
    accessor: COLUMN_ACCESSORS.CAD,
  },
  {
    Header: () => {
      return <HeaderCell header={STOP_TIME} classes={headerCellClasses} />;
    },
    Cell: () => {
      return <BodyCell value="02:00" classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.STOP_TIME],
    accessor: COLUMN_ACCESSORS.STOP_TIME,
  },
  {
    Header: () => {
      return <HeaderCell header={EXCEPTION} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      return (
        <BodyCell value={getExceptionEntry(value)} classes={bodyCellClasses} />
      );
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.EXCEPTION],
    accessor: COLUMN_ACCESSORS.EXCEPTION,
  },
  {
    Header: () => {
      return <HeaderCell header={WINDOW} classes={headerCellClasses} />;
    },
    Cell: ({ value }) => {
      return <BodyCell value={value} classes={bodyCellClasses} />;
    },
    columnConfig: columnsConfigs[COLUMN_ACCESSORS.WINDOW],
    accessor: COLUMN_ACCESSORS.WINDOW,
  },
];
